<div class="avatar" [ngClass]="{ dark: color === 'dark' }">
  <img *ngIf="src" [src]="src" [alt]="name">
  <span *ngIf="!src" [initialLetters]="name" [length]="length" [style]="'background: ' + bg"></span>
</div>